"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ShortcutBase_1 = require("./ShortcutBase");

var scenarioStatistics_1 = require("../../../models/query/scenarioStatistics");

var shortcuts_1 = require("../../../models/query/scenarioStatistics/shortcuts");

var object_1 = require("../../../utils/object");

var Query_1 = require("../../Query");

var collection_1 = require("../../../utils/collection");

var EntityRisksTableShortcut =
/** @class */
function (_super) {
  __extends(EntityRisksTableShortcut, _super);

  function EntityRisksTableShortcut(scenarioStatisticQuery) {
    return _super.call(this, scenarioStatistics_1.ScenarioStatisticShortcut.entityRisksTable, shortcuts_1.ShortcutType.directResponse, scenarioStatisticQuery) || this;
  }

  EntityRisksTableShortcut.prototype.getDirectResponse = function (shortcutOptions, scenarioStatistics) {
    var _this = this;

    var getTableRow = function getTableRow(options, entityResult, entity, portfolioEntity) {
      if (options === void 0) {
        options = {};
      }

      var response = {};
      var fields = options.fields;
      var workingExecutionOptions = object_1.deepMergeObjects(_this.scenarioStatisticQuery.executionOptions, {});

      if (entity || portfolioEntity) {
        if (!workingExecutionOptions.context) {
          workingExecutionOptions.context = {};
        }

        if (entity && entity.type) {
          if (!workingExecutionOptions.context.entityByType) {
            workingExecutionOptions.context.entityByType = {};
          }

          workingExecutionOptions.context.entityByType[entity.type] = entity;
        }

        if (portfolioEntity) {
          workingExecutionOptions.context.portfolioEntity = portfolioEntity;
        }
      }

      fields.forEach(function (field) {
        var key = field.key,
            entityQuery = field.entityQuery,
            statisticQuery = field.statisticQuery;
        var value = undefined;

        if (entityQuery) {
          var query = new Query_1.Query(entityQuery);
          value = query.execute(workingExecutionOptions);
        } else if (statisticQuery) {
          value = _this.scenarioStatisticQuery.getValueForEntity(entityResult, statisticQuery);
        }

        response[key] = value;
      });

      if (!portfolioEntity) {
        response['_isRiskRow'] = true;
      }

      return response;
    };

    var getEntityRiskStatistics = function getEntityRiskStatistics(period, type, entityRiskClientCode, comparisonId, defaultFund) {
      var response = defaultFund;

      if (entityRiskClientCode) {
        var entityRisk = period.entityRisks.find(function (entityRisk) {
          return entityRisk.clientCode === entityRiskClientCode;
        });

        if (entityRisk) {
          var funds = [];

          if (type === 'individual') {
            comparisonId = entityRisk.entityId.toString();
            funds = entityRisk.individual.funds;
          }

          if (type === 'comparison') {
            funds = entityRisk.comparison.funds;
          }

          if (funds && comparisonId) {
            response = funds.find(function (fund) {
              return fund.name === comparisonId;
            }) || defaultFund;
          }
        }
      }

      return response;
    };

    var tableOptions = shortcutOptions.options && shortcutOptions.options.entityRisksTable && shortcutOptions.options.entityRisksTable;
    var response = [];
    var periodType = this.scenarioStatisticQuery.getSinglePeriodType(shortcutOptions.periods);
    var portfolioId = this.scenarioStatisticQuery.getSinglePortfolioId(shortcutOptions.portfolios);

    if (periodType && portfolioId) {
      var riskEntities = this.scenarioStatisticQuery.scenario && this.scenarioStatisticQuery.scenario.riskEntities || [];
      var riskEntitiesByRelatedPortfolioId_1 = riskEntities.reduce(function (acc, riskEntity) {
        var _a = riskEntity.relatedPortfolioEntityIds,
            relatedPortfolioEntityIds = _a === void 0 ? [] : _a;
        relatedPortfolioEntityIds.forEach(function (portfolioEntityId) {
          acc[portfolioEntityId.toString()] = riskEntity;
        });
        return acc;
      }, {});
      var _a = scenarioStatistics.periods,
          periods = _a === void 0 ? [] : _a;
      var period_1 = periods.find(function (period) {
        return period.periodType === periodType;
      });

      if (period_1) {
        var _b = period_1.portfolios,
            portfolios = _b === void 0 ? [] : _b,
            benchmark = period_1.benchmark;

        var allPortfolios = __spreadArrays(portfolios);

        if (benchmark) {
          allPortfolios.push(benchmark);
        }

        var portfolio_1 = allPortfolios.find(function (portfolio) {
          return portfolio.id === portfolioId;
        });

        if (portfolio_1) {
          var _c = portfolio_1.funds,
              funds = _c === void 0 ? [] : _c;
          var orderedFunds = collection_1.sortBy(funds, function (fund) {
            var entityRisk = riskEntitiesByRelatedPortfolioId_1[fund.name];
            return entityRisk && entityRisk.clientCode || 'ZZZZZZZZZ';
          });
          var entityRisk_1;
          var scenarioPortfolio = this.scenarioStatisticQuery.scenario && this.scenarioStatisticQuery.scenario.portfolios && this.scenarioStatisticQuery.scenario.portfolios.find(function (scenarioPortfolio) {
            return _this.scenarioStatisticQuery.idEquals(scenarioPortfolio.portfolioId, portfolio_1.id);
          });

          if (scenarioPortfolio) {
            var portfolioEntities_1 = scenarioPortfolio.entities || [];
            response = orderedFunds.reduce(function (acc, fund) {
              var portfolioEntity = portfolioEntities_1.find(function (portfolioEntity) {
                return _this.scenarioStatisticQuery.idEquals(portfolioEntity.portfolioEntityId, fund.name);
              });

              if (portfolioEntity && portfolioEntity.entity) {
                var newEntityRisk = riskEntitiesByRelatedPortfolioId_1[fund.name];
                var fundRiskStatistics = getEntityRiskStatistics(period_1, 'comparison', newEntityRisk && newEntityRisk.clientCode, portfolioEntity.entityId.toString(), fund);
                var fundTableRow = getTableRow(tableOptions, fundRiskStatistics, portfolioEntity.entity, portfolioEntity);
                acc.push(fundTableRow);

                if (!newEntityRisk && entityRisk_1 || newEntityRisk && !entityRisk_1 || newEntityRisk && entityRisk_1 && newEntityRisk.clientCode !== entityRisk_1.clientCode) {
                  if (entityRisk_1) {
                    var riskEntityTableRow = getTableRow(tableOptions, getEntityRiskStatistics(period_1, 'individual', entityRisk_1.clientCode), entityRisk_1.entity);
                    acc.push(riskEntityTableRow);
                  }

                  entityRisk_1 = newEntityRisk;
                }
              }

              return acc;
            }, []);

            if (entityRisk_1) {
              var riskEntityTableRow = getTableRow(tableOptions, getEntityRiskStatistics(period_1, 'individual', entityRisk_1.clientCode), entityRisk_1.entity);
              response.push(riskEntityTableRow);
            }
          }
        }
      }
    }

    return response;
  };

  return EntityRisksTableShortcut;
}(ShortcutBase_1.ShortcutBase);

exports.EntityRisksTableShortcut = EntityRisksTableShortcut;